import type { Anime } from "@/mocks/animeData";

export default function AnimeCard({ anime }: { anime: Anime }) {
  return (
    <article className="group cursor-pointer overflow-hidden rounded-lg bg-background-100">
      <div className="relative aspect-[5/7] overflow-hidden">
        <img
          src={anime.image}
          alt={`${anime.title} 番剧封面`}
          title={`${anime.title} · ${anime.year}`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-transparent to-transparent opacity-70"></div>
        <span className="absolute left-3 top-3 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-bold text-foreground-950">
          {anime.type}
        </span>
        <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
          <span className="text-xs font-medium text-background-100">{anime.year}</span>
          <span className="flex items-center gap-1 text-sm font-bold text-accent-400">
            <i className="ri-star-fill"></i>
            {anime.rating.toFixed(1)}
          </span>
        </div>
      </div>
      <div className="p-4">
        <h3 className="line-clamp-1 font-heading text-base font-bold text-foreground-900 group-hover:text-primary-600">
          {anime.title}
        </h3>
        <p className="mt-1 line-clamp-1 text-xs text-foreground-500">{anime.original}</p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {anime.tags.slice(0, 3).map((tag) => (
            <span key={tag} className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}